require('./Tabs.scss');
require('./_Dark/Tabs_Dark.scss');

const b = require('app/www/libs/b')('tabs');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Select = require('app/www/components/blocks/Select/Select');

class Tabs extends React.PureComponent {

    constructor(props) {
        super(props);

        const {items, selectedId} = this.props;

        this.state = {
            selectedId: selectedId || items[0].id,
        };

        this._onClick = this._onClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {selectedId} = nextProps;

        if (this.state.selectedId !== selectedId) {
            this.setState({selectedId});
        }
    }

    render() {
        const {mods, itemsMore} = this.props;

        return (
            <div className={b(mods)}>
                <div className={b('wrapper')}>
                    {this._renderItems()}
                    {itemsMore && (
                        this._renderItemsMore()
                    )}
                </div>
            </div>
        );
    }

    /**
     * @private
     */
    _renderItems() {
        const {mods, items, itemsMore} = this.props;
        const {selectedId} = this.state;
        const selectedItem = items.filter(item => item.id === selectedId)[0];
        const selectedMoreItem = !selectedItem && (itemsMore || []).filter(moreItem => moreItem.id === selectedId)[0];

        return items.map((item, index) => {
            const isItemMore = index === items.length - 1 && selectedMoreItem;

            return isItemMore
                ? mods.calendar
                    ? this._renderItemMore(selectedMoreItem)
                    : [
                        this._renderItem(item),
                        this._renderItemMore(selectedMoreItem),
                    ]
                : this._renderItem(item);
        });
    }

    /**
     * @param {Object} item
     * @returns {Object}
     * @private
     */
    _renderItem(item) {
        const {selectedId} = this.state;

        const itemProps = {
            className: b('item', {
                past: item.isPast,
                disabled: item.isDisabled,
                selected: item.id === selectedId,
            }),
        };

        if (!item.isDisabled) {
            itemProps.onClick = this._onClick(item.id);
        }

        return (
            <span
                key={item.id}
                {...itemProps}
            >
                {item.text}
                {typeof item.count === 'number' && (
                    <i className={b('count')}>{item.count}</i>
                )}
            </span>
        );
    }

    /**
     * @param {Object} itemMore
     * @returns {Object}
     * @private
     */
    _renderItemMore(itemMore) {
        const itemMoreProps = {
            className: b('item', {
                selected: true,
            }),
        };

        return (
            <span key={itemMore.id} {...itemMoreProps}>
                {itemMore.tabText}
            </span>
        );
    }

    /**
     * @returns {Object}
     * @private
     */
    _renderItemsMore() {
        const {i18n, mods, itemsMore} = this.props;
        const {selectedId} = this.state;

        const selectProps = {
            mods: {
                size: 'm',
                theme: 'clear',
                'no-arrow': true,
            },
            options: itemsMore.map(item => ({
                attrs: {
                    id: item.id,
                    value: item.id,
                    selected: item.id === selectedId,
                },
                content: item.selectText,
            })),
            popupProps: {mods},
            onChange: this._onClick(),
            children: i18n.get('tabs.more'),
        };

        if (mods.calendar) {
            Object.assign(selectProps, {
                className: b('calendar'),
                icon: {
                    calendar: true,
                },
            });

            Object.assign(selectProps.mods, {
                size: 's',
                calendar: true,
                'only-icon': true,
            });
        }

        return <Select {...selectProps} />;
    }

    /**
     * @param {Number} [renderId]
     * @returns {Object}
     * @private
     */
    _onClick(renderId) {
        const {mods} = this.props;

        return (callbackId) => {
            const selectedId = renderId || callbackId;

            if (this.state.selectedId !== selectedId) {
                this.setState({selectedId});

                this.props.onChange(selectedId, Boolean(mods.calendar));
            }
        };
    }

}

Tabs.defaultProps = {
    mods: {},
    onChange: () => {},
};

Tabs.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        count: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
        isDisabled: PropTypes.bool,
    })).isRequired,
    itemsMore: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        tabText: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        selectText: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    })),
    selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
};

module.exports = withI18n(Tabs);
